import request from '@/utils/request'

export function pageAnnouncementAuditor (query) {
  return request({
    url: '/diandian/announcement-auditor/page',
    method: 'get',
    params: query
  })
}

export function listAnnouncementAuditor (query) {
  return request({
    url: '/diandian/announcement-auditor/list',
    method: 'get',
    params: query
  })
}

export function getAnnouncementAuditor (data) {
  return request({
    url: '/diandian/announcement-auditor/detail',
    method: 'get',
    params: data
  })
}

export function addAnnouncementAuditor (data) {
  return request({
    url: '/diandian/announcement-auditor/add',
    method: 'post',
    data: data
  })
}

export function updateAnnouncementAuditor (data) {
  return request({
    url: '/diandian/announcement-auditor/edit',
    method: 'post',
    data: data
  })
}

export function delAnnouncementAuditor (data) {
  return request({
    url: '/diandian/announcement-auditor/delete',
    method: 'post',
    data: data
  })
}
